import { RepConnWrapper } from 'src/app/modules/repconn/repconn.wrapper';
import { DataObjectWrapper } from 'src/app/modules/dataobject/dataobject.wrapper';
import { Database } from './database';
import { Datatype } from './datatype';
import { CommonEnums } from '../common.enums';
import { AttributeTabulator } from 'src/app/shared/grids/attributes/attribute.tabulator';
import { Business_GlossaryTabulator } from 'src/app/shared/grids/business_glossary/business_glossary.tabulator';
import { ObjectWrapper } from '../wrappers/object.wrapper';
import { LabelValueObj } from '../beans/labelvalueobj';
import { Conn_DbTabulator } from 'src/app/shared/grids/conn_dbs/conn_db.tabulator';
import { LAttributeTabulator } from 'src/app/shared/grids/lattributes/lattribute.tabulator';
import { Attribute } from '../models/domain/attribute';
import { Attribute1 } from '../models/domain/attribute1';
import { DatabaseEnum } from './databases.enum';
import { TargetWrapper } from 'src/app/modules/design/transforms/target/target.wrapper';
import { Tgt_Attr_LnkTabulator } from 'src/app/shared/grids/tgt_attr_lnks/tgt_attr_lnk.tabulator';
import { Output_Attr_LnkTabulator } from '../grids/output_attr_lnks/output_attr_lnk.tabulator';
import { OutputWrapper } from 'src/app/modules/design/transforms/output/output.wrapper';
;

export class DatabaseWrapper {
    database: Database;
    dataObjectWrapper:DataObjectWrapper;
    datatypesMap: Map<string, Datatype>;

    labelValueObjs: Array<LabelValueObj>;
    isCaseSensitive: boolean;

    dbTyp_Id: number;
    name: string;
    code: string;
    icon: string;
    dBname: string;

    showDataTab: boolean;
    isComplexType: boolean;
    isParentChild: boolean;
    showClevel: boolean;
    isNeedRedirectForTestDP: boolean;
    showProjectIdColumnInConnDb: boolean;

    nativeDbTyp_Ids: Array<number>;
    // UDF Variables Declaration
    udfClassLabelName: string;
    showUDFMethod: boolean;
    showSyntaxMethod: boolean;
    conn_DbsTabName: string;
    equivalentTag: string;
    databaseNm: string;
    schemaNm: string;
    maxLength: number;
    // Attributes
    canAddElement: boolean;
    readOnlyAttributes: boolean;
    isShowPIIColumn: boolean;

    showOnlyExtractProperties: boolean;
    showOnlyLoadProperties: boolean;
    showExtractPropertiesTab: boolean;
    showAdvancePropertiesTab: boolean;
    showRunTimePropertiesTab: boolean;
    showLoadPropertiesTab: boolean;
    showDatabaseTab: boolean;
    showRestPropertiesTab: boolean;
    showSettingsTab: boolean;
    showDatabase: boolean;
    showPropertiesTab: boolean;
    hideDatabaseNmDbColumn: boolean;
    showRestPIParametersTab: boolean;

    showHdfsSettingsTab: boolean;
    showStreamingSettingsTab: boolean;
    showKerberosSettingsTab: boolean;
    showYARNSettingsTab: boolean;
    showHBASESettingsTab: boolean;
    showZooKeeperSettingsTab: boolean;
    showStatisticsSettingsTab: boolean;
    showSharePointStageTab: boolean;
    showMapReduceSettingsTab: boolean;
    showAmazonS3StageTab: boolean;
    disableCreateAsTransient: boolean;

    getSchemasOnDbNm: boolean;

    attributeTabulator: AttributeTabulator;
    business_glossaryTabulator: Business_GlossaryTabulator;
    lAttributeTabulator: LAttributeTabulator;
    tgt_Attr_LnkTabulator: Tgt_Attr_LnkTabulator;
    output_Attr_LnkTabulator: Output_Attr_LnkTabulator;
    conn_DbsTabultor: Conn_DbTabulator;

    excludedAttrNms: Array<string>;
    attributeColumns: Array<any>;
    attribute1Columns: Array<any>;
    lattributeColumns: Array<any>;

    fewDerivedAttributeColumns: Array<any>;
    //derivedAttributeColumns: Array<any>;
    //sourceAttributeColumns: Array<any>;
    fewAttributeColumns: Array<any>;
    outputMapperColumns: Array<any>;
    fewSourceAttributeColumns: Array<any>;
    isFileType: boolean;

    isShowColFormat: boolean;
    isEncryptedFlag: boolean;
    isCDC: boolean;

    havingOnlySchemalColumn: boolean;
    showUserPrincipal: boolean;
    // data object tabs
    showViewDataTabOption: boolean;
    showDDLOption: boolean;
    showDataObjectPropertiesTab: boolean;
    //propertiesgrid in dataobject
    isShowObjProperties: boolean;
    dataObjectConnDatabaseNm: string;

    showFileTypeGroup: boolean; // delimiter and fixed width group
    showDelimiter: boolean;
    showFixedWidth: boolean;
    showAvroTypeGroup: boolean;
    showParquetTypeGroup: boolean;
    showParquet: boolean;
    showPromoteAttributes: boolean;
    showDemoteAttributes: boolean

    showOverWritePartition: boolean
    showDistAttributes: boolean;
    complexAttrDTyp_Ids: Array<any>;

    attributesMode_Ind: string;
    attributes1Mode_Ind: string;
    databaseNmDbColumnName: string;
    showRepConnFileEncryption: boolean;
    defaultMssqlDatabaseName: string;
    showRepConnServiceNm: boolean;
    hideSchemaNmColumn: boolean;

    showStaticObject: boolean;
    showStreamObject: boolean;

    showTerminateEndDate: boolean;
    showMultipleVersionsUniqueKeyinSource: boolean;

    isAlwaysUncheckDisable: boolean;
    showTruncBeforeField: boolean;
    showExtractProperties: boolean;
    showLoadProperties: boolean;
    extractPropertiesLabel: string;
    loadPropertiesLabel: string;

    showDSA: boolean;
    timeStampAttrDbTyp_Id: number;

    showTablePartitionTab: boolean;
    disableTestDataPointButton: boolean;
    isNamedInstance: boolean;
    isInstanceNameDisable: boolean;
    showDataDescription: boolean;
    
    isIcebergEndpointDisable: boolean = false;
    isIcebergAccessKeyInstance: boolean = false;
    isIcebergSecretKeyInstance: boolean  = false;
    isIcebergMetastoreUriInstance: boolean = false;
    isIcebergTrinoUsrnm: boolean = false;
    isIcebergTrinoPswrd: boolean = false;

    constructor(databaseTmp: Database) {
        this.database = databaseTmp;
        this.datatypesMap = new Map<string, Datatype>();

        this.isCaseSensitive = false;
        this.isComplexType = this.database.complex == CommonEnums.flag.YES;
        this.isParentChild = this.database.hasParentChild == CommonEnums.flag.YES;
        this.attributesMode_Ind = CommonEnums.mode_Ind.WRITE;

        this.showClevel = this.isComplexType || this.isParentChild; //false;
        this.havingOnlySchemalColumn = false;

        this.isNeedRedirectForTestDP = false;
        this.showProjectIdColumnInConnDb = false;
        this.hideDatabaseNmDbColumn = false;
        this.hideSchemaNmColumn = true;
        this.showDSA = false;

        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.name = CommonEnums.defaults.STRING_EMPTY;
        this.code = CommonEnums.defaults.STRING_EMPTY;


        this.extractPropertiesLabel = 'Extract Properties';
        this.loadPropertiesLabel = 'Load Properties';

        this.udfClassLabelName = 'Class Name';
        this.databaseNm = 'DATABASE_1';
        this.schemaNm = 'default';
        this.defaultMssqlDatabaseName = "default";
        this.showUDFMethod = false;
        this.showSyntaxMethod = false;
        this.showTerminateEndDate = false;
        this.showMultipleVersionsUniqueKeyinSource = false;
        this.showDataTab = true;
        this.showDatabaseTab = true;
        this.showRunTimePropertiesTab = false;
        this.showLoadPropertiesTab = true;
        this.showExtractPropertiesTab = true;
        this.showAdvancePropertiesTab = true;
        this.showRestPIParametersTab = false;

        this.showRestPropertiesTab = false;
        this.showRepConnServiceNm = false;
        this.showSettingsTab = false;

        this.showHdfsSettingsTab = false;
         this.showStreamingSettingsTab = false;
        this.showKerberosSettingsTab = false;
        this.showYARNSettingsTab = false;
        this.showHBASESettingsTab = false;
        this.showSharePointStageTab = false;
        this.showZooKeeperSettingsTab = false;
        this.showStatisticsSettingsTab = false;
        this.showMapReduceSettingsTab = false;
        this.showAmazonS3StageTab = false;
        this.disableCreateAsTransient = false;
        this.showDatabase = true;
        this.showOnlyLoadProperties = false;
        this.showOnlyExtractProperties = false;
        this.isShowPIIColumn = false;

        this.getSchemasOnDbNm = false;

        this.nativeDbTyp_Ids = new Array<number>();
        this.nativeDbTyp_Ids = new Array<number>();
        this.excludedAttrNms = new Array<string>();
        this.attributeColumns = new Array<any>();
        this.attribute1Columns = new Array<any>();
        this.lattributeColumns = new Array<any>();
        //this.derivedAttributeColumns = new Array<any>();
        this.fewDerivedAttributeColumns = new Array<any>();
        //   this.sourceAttributeColumns = new Array<any>();
        this.outputMapperColumns = new Array<any>();
        this.fewAttributeColumns = new Array<any>();
        this.fewSourceAttributeColumns = new Array<any>();
        this.labelValueObjs = new Array<LabelValueObj>();

        this.attributeTabulator = AttributeTabulator.getInstance();
        this.business_glossaryTabulator = Business_GlossaryTabulator.getInstance();
        this.lAttributeTabulator = LAttributeTabulator.getInstance();
        this.tgt_Attr_LnkTabulator = Tgt_Attr_LnkTabulator.getInstance();
        this.output_Attr_LnkTabulator = Output_Attr_LnkTabulator.getInstance();
        this.conn_DbsTabultor = new Conn_DbTabulator();

        this.isShowColFormat = false;
        this.isEncryptedFlag = false;
        this.isCDC = false;

        this.equivalentTag = '';
        this.conn_DbsTabName = 'Databases';

        this.databaseNmDbColumnName = "Database";

        this.showUserPrincipal = false;
        // data object tabs
        this.showDataObjectPropertiesTab = false;
        this.showViewDataTabOption = false;
        this.showDDLOption = false;
        this.isShowObjProperties = false;
        this.dataObjectConnDatabaseNm = 'Database';
        this.isFileType = false;
        this.showPropertiesTab = true;
        this.resetImportFileProperties();
        this.showPromoteAttributes = false;
        this.showDemoteAttributes = false;
        this.showOverWritePartition = false;
        this.showDistAttributes = false;
        this.maxLength = 128;

        this.showStaticObject = false;
        this.showStreamObject = false;

        this.isAlwaysUncheckDisable = false;
        this.showTruncBeforeField = false;
        this.showExtractProperties = true;
        this.showLoadProperties = true;
        this.timeStampAttrDbTyp_Id = 93;
        this.showTablePartitionTab = false;
        this.disableTestDataPointButton = false;
        this.showDataDescription = false;

	    this.isNamedInstance = false;
        this.isInstanceNameDisable = false;

        this.isIcebergEndpointDisable = false;
        this.isIcebergAccessKeyInstance = false;
        this.isIcebergSecretKeyInstance  = false;
        this.isIcebergMetastoreUriInstance = false;

    }

    /**
     * @param repConnWrapper
     *
     * @description
     * If any databases having specific rules for Repconn Object,
     * then override validateRepConn() method and implement accordingly.
     */
    validateRepConn(repConnWrapper: RepConnWrapper): void { }

    /**
     * @param repConnWrapper
     *
     * @description
     * If any databases having specific rules for DataObject,
     * then override validateDataObject() method and implement accordingly.
     */
    validateDataObject(dataObjectWrapper: DataObjectWrapper): void { }

    showAttributeTranspose(attribute: Attribute, objectWrapper: ObjectWrapper): boolean {
        return false;
    }

    // showAttributeNotNull(attribute: Attribute, objectWrapper: ObjectWrapper): boolean {
    //     return true;
    // }
    hideNotNullFlag(attribute: Attribute): boolean {

        return false;
    }
    hideAttrKeyTyp_Id(attribute: Attribute): boolean {

        return false;
    }


    /**
     * getBaseAttributeColumns() will be basic attributes column.
     * This method will be derived by all databases wrappers and implement it.
     *
     * @param objectWrapper
     * @param mode_Ind
     *
     * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
     * Tab: data object attributes columns sheet
     *
    */
    getBaseAttributeColumns(objectWrapper: ObjectWrapper, mode_Ind: string = CommonEnums.mode_Ind.WRITE, hideRowSelection: boolean = true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, null),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
        ]
    }

    /**
     * getAttributeColumns() will be default Data Object attributes column.
     * This method will be derived by all databases wrappers and implement it.
     * @param objectWrapper
     * @param attributes
     * @param component
     *
     * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
     * Tab: data object attributes columns sheet
     *
    */
//    getAttributeColumns(objectWrapper: ObjectWrapper,
//     attributes: Array<Attribute> = new Array<Attribute>(), component: any = null, hideRowSelection: boolean = true, isNewTab: boolean = false): Array<any> {
//     if (isNewTab) {
//       // Logic for generating columns for a new tab
//       return [
//         this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
//         this.attributeTabulator.getSrt_Order(),
//         this.attributeTabulator.getAttr_Id(),
//         this.attributeTabulator.getAttrNm(objectWrapper, component),
//         this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
//         this.attributeTabulator.getAttrPrec(objectWrapper),
//         this.attributeTabulator.getDescription(objectWrapper)
//       ];
//     } else {
//       // Logic for generating columns when clicking on an attribute
//       return [
//         this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
//         this.attributeTabulator.getSrt_Order(),
//         this.attributeTabulator.getAttr_Id(),
//         this.attributeTabulator.getAttrNm(objectWrapper, component),
//         this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
//         this.attributeTabulator.getAttrPrec(objectWrapper),
//         this.attributeTabulator.getAttrScale(objectWrapper),
//         this.attributeTabulator.getNotNullFlag(objectWrapper),
//         this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
//         this.attributeTabulator.getDescription(objectWrapper)
//       ];
//     }
//   }
    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null, hideRowSelection: boolean = true): Array<any> {
        //isEncryptedFlag: boolean = false
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getNotNullFlag(objectWrapper),
            this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
            this.attributeTabulator.getDescription(objectWrapper),
        ]
    }
    getAttributeColumnss(objectWrapper: ObjectWrapper, descriptions: any,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null, hideRowSelection: boolean = true): Array<any> {
        //isEncryptedFlag: boolean = false
        return [
            this.business_glossaryTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
            this.business_glossaryTabulator.getSrt_Order(),
            this.business_glossaryTabulator.getAttr_Id(),
            this.business_glossaryTabulator.getAttrNm(objectWrapper, component),
            this.business_glossaryTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            //this.attributeTabulator.getAttrPrec(objectWrapper),
            //this.attributeTabulator.getAttrScale(objectWrapper),
            this.business_glossaryTabulator.getNotNullFlag(objectWrapper),
            this.business_glossaryTabulator.getAttrKeyTyp_Id(objectWrapper),
            this.business_glossaryTabulator.getDescription1(objectWrapper),
        ]
    }


    /**
    * getLAttributeColumns() will be default Data Object attributes column.
    * This method will be derived by all databases wrappers and implement it.
    *
    * @param objectWrapper
    * Ref: guide\docs\studio\lattributes\database-lattributes-columns.xlsx
    * Tab: lattributes columns sheet
    *
   */
    getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            this.lAttributeTabulator.getLAttrScale(objectWrapper),
            this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component),
            this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
            this.lAttributeTabulator.getPartFlag(objectWrapper, component),
            this.lAttributeTabulator.getOrderBy(objectWrapper, component)
        ]
    }

    getSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            this.lAttributeTabulator.getLAttrScale(objectWrapper),
        ]
    }

    getJoinerSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectLAttrColumn(objectWrapper),
            // this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            // this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            // this.lAttributeTabulator.getLAttrScale(objectWrapper),
        ]
    }


    // getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper, component: any = null): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //         this.lAttributeTabulator.getLAttrType(objectWrapper),
    //         this.lAttributeTabulator.getLAttrFunction(objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component),
    //         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper, component),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper, component)
    //     ]
    // }

    /**
       * getSourceAttributeColumns() will be default Data Object attributes column.
       * This method will be derived by all databases wrappers and implement it.
       *
       * @param objectWrapper
       * @param isComplex
       *
       * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
       * Tab: data object attributes columns sheet
       *
      */
    getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false,
        isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false,
        isMax: boolean = false, component: any = '') {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }

    /**
     * getDerivedAttributeColumns() will be default Data Object attributes column.
     * This method will be derived by all databases wrappers and implement it.
     *
     * @param objectWrapper
     * @param isMax
     * @param component
     *
     * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
     * Tab: derived attributes columns sheet
     *
    */
    getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean, hideOrderBy: boolean = true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
            this.attributeTabulator.getOrderBy(objectWrapper, component, hideOrderBy),
            this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
            this.attributeTabulator.getAttrExprVal(objectWrapper, component),
            this.attributeTabulator.getValid_Cd(objectWrapper, component)
        ]
    }

    /**
     * getDerivedAttributeColumns() will be default Data Object attributes column.
     * This method will be derived by all databases wrappers and implement it.
     *
     * @param objectWrapper
     * @param isMax
     * @param component
     *
     * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
     * Tab: derived attributes columns sheet
     *
    */
    getSelectTransAttributeColumns(objectWrapper: ObjectWrapper, component: any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getUnique(objectWrapper, component),
            this.attributeTabulator.getSortBy(objectWrapper, component),
            this.attributeTabulator.getAscDsc(objectWrapper),
            this.attributeTabulator.getAttrExprVal(objectWrapper, component),
            this.attributeTabulator.getValid_Cd(objectWrapper, component)
        ]
    }

    /**
     * getOutputMapperColumns() will be default Data Object attributes column.
     * This method will be derived by all databases wrappers and implement it.
     *
     * @param objectWrapper
     * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
     * Tab: data object attributes columns sheet
     *
    */
    getOutputMapperColumns(objectWrapper: ObjectWrapper) {
        return [

            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, null),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getOutPutLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getOutPutLnk_Attr_Datatype(objectWrapper),
            //this.attributeTabulator.getValid_Cd(outputWrapper),
        ]
    }

    /**
     * getConn_DbColumns() will be default Data Object attributes column.
     * This method will be derived by all databases wrappers and implement it.
     *
     * @param repConnWrapper
     * Ref: guide\docs\studio\attributes\database-attributes-columns.xlsx
     * Tab: data object attributes columns sheet
     *
    */
    getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any = ''): Array<any> {
        let showTranspose: boolean = false;
        if (repConnWrapper.dbTyp_Id == DatabaseEnum.saphana.ID)
            showTranspose = true;

        return [
            this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
            this.conn_DbsTabultor.getSrt_Order(),
            this.conn_DbsTabultor.getName(repConnWrapper),
            this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),
            this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component),
            this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper, showTranspose)
        ]
    }

    getTgt_Attr_LnkColumns(dbTyp_Id: number, tgtLoadType: string, targetWrapper: TargetWrapper): Array<any> {
        let columns: Array<any> = new Array<any>();

        // columns.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper));
        // columns.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper));
        // columns.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper));
        // columns.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper));

        // if (tgtLoadType != 'INS') {
        //     columns.push(this.tgt_Attr_LnkTabulator.getUpdKeyFlag(targetWrapper));
        // }

        // if (tgtLoadType == 'SCD') {
        //     columns.push(this.tgt_Attr_LnkTabulator.getScdFlag(targetWrapper));
        //     columns.push(this.tgt_Attr_LnkTabulator.getScdStartDtFlag(targetWrapper));
        //     columns.push(this.tgt_Attr_LnkTabulator.getScdEndDtFlag(targetWrapper));
        //     columns.push(this.tgt_Attr_LnkTabulator.getCurrIndFlag(targetWrapper));
        // } else if (tgtLoadType == 'UPI') {
        //     columns.push(this.tgt_Attr_LnkTabulator.getInsert_Column(targetWrapper));
        //     columns.push(this.tgt_Attr_LnkTabulator.getUpdate_Column(targetWrapper));
        // }

        // columns.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper));

        // return columns;



        switch (dbTyp_Id) {

            case DatabaseEnum.databaseId.AVRO: return [
                columns.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper)),
            ]

            case DatabaseEnum.databaseId.PARQUET: return [
                columns.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper)),
                columns.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper)),
            ]

            case DatabaseEnum.databaseId.SALESFORCE: let columnsTmp: Array<any> = new Array<any>()

                columnsTmp.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper));
                columnsTmp.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper));
                columnsTmp.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper));
                columnsTmp.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper));

                if (tgtLoadType != 'INS') {
                    columnsTmp.push(this.tgt_Attr_LnkTabulator.getUpdKeyFlag(targetWrapper));
                }
                columnsTmp.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper));

                return columnsTmp;

            case DatabaseEnum.databaseId.HIVE: var _columns = [];
                _columns.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper))
                _columns.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper))
                _columns.push(this.tgt_Attr_LnkTabulator.getOrderBy(targetWrapper))
                _columns.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper))
                _columns.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper))

                if (tgtLoadType != 'INS') {
                    _columns.push(this.tgt_Attr_LnkTabulator.getUpdKeyFlag(targetWrapper));
                }

                if (tgtLoadType == 'SCD') {
                    _columns.push(this.tgt_Attr_LnkTabulator.getScdFlag(targetWrapper));
                    _columns.push(this.tgt_Attr_LnkTabulator.getHashKey(targetWrapper));
                    _columns.push(this.tgt_Attr_LnkTabulator.getScdStartDtFlag(targetWrapper));
                    _columns.push(this.tgt_Attr_LnkTabulator.getScdEndDtFlag(targetWrapper));
                    _columns.push(this.tgt_Attr_LnkTabulator.getCurrIndFlag(targetWrapper));
                    _columns.push(this.tgt_Attr_LnkTabulator.getSurrogate_Key(targetWrapper));
                }

                _columns.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper));

                return _columns;

            default: let _columnsTmp = [];
                _columnsTmp.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper))
                _columnsTmp.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper))
                _columnsTmp.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper))
                _columnsTmp.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper))

                if (tgtLoadType != 'INS') {
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getUpdKeyFlag(targetWrapper));
                }

                if (tgtLoadType == 'SCD') {
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getScdFlag(targetWrapper));
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getScdStartDtFlag(targetWrapper));
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getScdEndDtFlag(targetWrapper));
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getCurrIndFlag(targetWrapper));
                } else if (tgtLoadType == 'UPI') {
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getInsert_Column(targetWrapper));
                    _columnsTmp.push(this.tgt_Attr_LnkTabulator.getUpdate_Column(targetWrapper));

                }

                _columnsTmp.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper));

                return _columnsTmp;

        }

    }

    getDatabase(dbTyp_Id: number) {
        // let database: Database = this.databaseWrappersCache..get(dbTyp_Id);
    }

    hideFldFormatValue(attribute: Attribute): boolean {
        return false;
    }

    resetImportFileProperties(): void {
        this.showFileTypeGroup = false; // delimiter and fixed width group
        this.showDelimiter = false;
        this.showFixedWidth = false;
        this.showAvroTypeGroup = false;
        this.showParquetTypeGroup = false;
        this.showParquet = false;
    }

    getTransposeAttributeColumns(objectWrapper: ObjectWrapper, attributes: Array<Attribute>, transposetype: string) {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, null),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getTransposeKeyColumn(objectWrapper, transposetype),
            this.attributeTabulator.getTransposeDataColumn(objectWrapper, attributes, transposetype),
            //AttributeColumns.getValid_Cd()

        ]

    }

    getMaskingAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false,
        attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false): Array<any> {
        return [
        ]
    }

    readFileCutOffLength(type: string): number {
        return -1;
    }


}
